var REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
export function isUuid(value) {
  return typeof value === 'string' && value.length === 36 && REGEX.test(value);
}